exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".BodyText__BodyText__1EBvi {\n  position: relative;\n  width: 100%;\n  height: 226px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  z-index: 1; }\n  @media only screen and (device-aspect-ratio: 40 / 71) {\n    .BodyText__BodyText__1EBvi {\n      margin-top: -23px;\n      height: 170px; } }\n", ""]);

// exports
exports.locals = {
	"BodyText": "BodyText__BodyText__1EBvi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/circleci/project/src/styles"]}!./src/app/intro/components/BodyText/BodyText.scss
// module id = 508
// module chunks = 0